import React from "react"
import appConfig from "../app-config"
import { useHornetSession } from "../hooks/use-hornet-session"
import { WebSocketProvider } from "@hornet-web-react/core/contexts/websocket.context"

export const HornetWebSocketProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const { data: fullSession } = useHornetSession()

  return (
    <WebSocketProvider
      appConfigMqttHost={appConfig.mqtt.host}
      pubSubConfig={fullSession?.pubSubConfig}
    >
      {children}
    </WebSocketProvider>
  )
}
